import { render, staticRenderFns } from "./PromotionView.vue?vue&type=template&id=90df2228&"
import script from "./PromotionView.vue?vue&type=script&lang=js&"
export * from "./PromotionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports